import React from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";


interface Props {
  onTapCloseModal: () => void;
  onTapCompleteModal: () => void;
}

export const ConfirmAddAccountInfoModal = ({ onTapCloseModal, onTapCompleteModal }: Props) => {
  return (
    <BasePageModal
      handleClose={onTapCloseModal}
      title=""
      className=""
      bottomChildren={
        <>
          <BaseRoundButton
            buttonText="はい"
            onClick={() => {
              onTapCompleteModal();
            }}
          />
          <BaseRoundButton
            buttonText="いいえ"
            onClick={() => {
              onTapCloseModal();
            }}
          />
        </>
      }
      disableOverlayClose={true}
    >
      <p>引き続き同アカウントの口座を追加しますか？</p>
    </BasePageModal>
  );
};
